import React, {useContext, useEffect, useState} from "react";
import {Box, Button} from "@mui/material";
import {SectionIndicatorContext} from "../shared/contexts/SectionIndicatorContext";
import {DefaultValues, FieldValues, KeepStateOptions} from "react-hook-form";
import LoadingButton from "../layoutComponents/LoadingButton";
import {makeStyles} from "@material-ui/core";
import {ForwardBtnTitleEnum, SendEmailAgainEnum} from "../shared/enums/button-title.enum";

/**
 * Controls sections(pages) of a reg process
 * EMAIL-FLOW
 * sectionNumber 0 - Navigation
 * sectionNumber 1 - EmailVerification
 * sectionNumber 2 - EmailSuccess
 * PHONE-FLOW
 * sectionNumber 3 - PhoneVerificaton
 * sectionNumber 4 - PhoneEmailVerification
 * PASSWORD
 * sectionNumber 5 - optional - AccountSelect (if only one account this wont render)
 * sectionNumber 6 - SetPassword
 * sectionNumber 7 - SetPasswordSuccess

 */

interface FooterButtonsProps {
	isLoading?: boolean;
	navigateTo?: string;
	isInitAppLoading?: boolean;
	reset?: (values?: DefaultValues<FieldValues> | FieldValues, keepStateOptions?: KeepStateOptions) => void;
	pinValue?: string;
	watch?: (names: string) => string;
	sendSecondEmail?: () => void;
}

const useStyles = makeStyles((theme) => ({
	FooterButtons: {
		display: "flex",
		flexDirection: "column",
		alignSelf: "flex-end",
		flexGrow: 1,
		gap: "1.6rem",
		marginBottom: "2.4rem",
		"& > *": {
			flexGrow: 0,
		},
	},
}));

const FooterButtons = ({ isLoading, isInitAppLoading, watch, sendSecondEmail }: FooterButtonsProps) => {
	const { sectionNumber } = useContext(SectionIndicatorContext);
	const [forwardButtonTitle, setForwardButtonTitle] = useState<string>();
	const styles = useStyles();

	const disableForShortPin = (watch && sectionNumber === 3) && watch('pin').length < 6;

	useEffect(() => {
		handleForwardButtonTitle();
	}, [sectionNumber]);

	function handleForwardButtonTitle(): void {
		switch (sectionNumber) {
			case 0:
				setForwardButtonTitle(ForwardBtnTitleEnum.TITLE_3);
				break;
			case 1:
				setForwardButtonTitle(ForwardBtnTitleEnum.TITLE_1);
				break;
			case 2:
				setForwardButtonTitle(ForwardBtnTitleEnum.TITLE_2);
				break;
			case 3:
				setForwardButtonTitle(ForwardBtnTitleEnum.TITLE_3);
				break;
			case 4:
				setForwardButtonTitle(ForwardBtnTitleEnum.TITLE_4);
				break;
			case 5:
				setForwardButtonTitle(ForwardBtnTitleEnum.TITLE_5);
				break;
			case 6:
				setForwardButtonTitle(ForwardBtnTitleEnum.TITLE_6);
				break;
			case 7:
				setForwardButtonTitle(ForwardBtnTitleEnum.TITLE_7);
				break;
		}
	}

	function handleButtonClick(buttonDirection: string): void {
		if (buttonDirection === "sendAgain") {
			sendSecondEmail && sendSecondEmail();
		}
	}

	return (
		<Box className={styles.FooterButtons}>
			<LoadingButton disabled={disableForShortPin} loading={isLoading || isInitAppLoading}>
				{forwardButtonTitle}
			</LoadingButton>
			{sectionNumber === 2 && (
				<Button variant="text" onClick={() => handleButtonClick("sendAgain")}>
					{SendEmailAgainEnum.TITLE_1}
				</Button>
			)}
		</Box>
	);
};

export default FooterButtons;
